module.exports = "https://cdn.hellotech.com/client-assets/inhome-discounts_3b945db8dc42fcd9da970197fc3b1bf7.svg";